import './controls.css';

export interface SliderOptions {
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
}

export interface SliderHandle {
  readonly el: HTMLElement;
  setValue(value: number): void;
  destroy(): void;
}

export function createSlider(opts: SliderOptions): SliderHandle {
  const min = opts.min ?? 0;
  const max = opts.max ?? 100;
  const step = opts.step ?? 1;

  const el = document.createElement('div');
  el.className = 'fg-slider';

  const input = document.createElement('input');
  input.type = 'range';
  input.className = 'fg-slider__input';
  input.min = String(min);
  input.max = String(max);
  input.step = String(step);
  input.value = String(opts.value);
  el.appendChild(input);

  const readout = document.createElement('span');
  readout.className = 'fg-slider__value';
  readout.textContent = String(opts.value);
  el.appendChild(readout);

  function updateFill(v: number) {
    const pct = ((v - min) / (max - min)) * 100;
    input.style.setProperty('--_pct', `${pct}%`);
  }
  updateFill(opts.value);

  function handler() {
    const v = Number(input.value);
    readout.textContent = String(v);
    updateFill(v);
    opts.onChange(v);
  }
  input.addEventListener('input', handler);

  return {
    el,
    setValue(v) {
      input.value = String(v);
      readout.textContent = String(v);
      updateFill(v);
    },
    destroy() {
      input.removeEventListener('input', handler);
      el.remove();
    },
  };
}
